import { type IRateCalculatorContext, RateCalculatorContext } from 'BreetComponents';
import { useContext } from 'react';

export const useRateCalculatorContext = (): IRateCalculatorContext => {
	const rateCalculatorContext = useContext(RateCalculatorContext);

	if (!rateCalculatorContext) {
		throw new Error('useRateCalculatorContext must be used within a RateCalculatorProvider');
	}

	return rateCalculatorContext;
};
